import { t, useLocale } from '../localization/adminText';
import { Badge, Tooltip } from './admin-ui';
import { riskScore, riskScoreTone } from '../utils/riskScore';

export default function RiskScoreBadge({ order }) {
  useLocale();
  if ((order.type || order.order_type) === 'online' || order.risk_level === 'not_applicable') return <Badge tone="info">{t('Online')}</Badge>;
  const score = riskScore(order);
  const description = score === null ? t('Risk score unavailable') : t('The score combines ordering behavior and confirmed refusal history, not a refusal probability.');
  return <Tooltip content={description}><span aria-label={score === null ? description : t('Risk score: {0}', [score])}>
    <Badge tone={riskScoreTone(score)}>{score ?? '—'}</Badge>
  </span></Tooltip>;
}
